import { z } from "zod";

import {
  TrafficConfigDtoSchema,
  TrafficConfigQueryParamsDtoSchema,
} from "../../../../../dtos/deprecated/traffic-configs";

const PluginTrafficConfigQueryParamsSchema =
  TrafficConfigQueryParamsDtoSchema.omit({ id: true });

export type PluginTrafficConfigQueryParamsType = z.infer<
  typeof PluginTrafficConfigQueryParamsSchema
>;

export const PluginTrafficConfigSchema_2023_08_20 = TrafficConfigDtoSchema.omit(
  {
    id: true,
  }
).extend({
  elseAction: z.any(),
  queryParams: z
    .optional(PluginTrafficConfigQueryParamsSchema.array())
    .default([]),
});
export type PluginTrafficConfigType_2023_0_20 = z.infer<
  typeof PluginTrafficConfigSchema_2023_08_20
>;
